var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditUsedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1-1_credits",
    "data-name": "1-1 credits",
    transform: "translate(-618.36 -450.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message_Sent_20px",
    "data-name": "Message Sent_20px",
    transform: "translate(626.86 451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(1.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M114.7,0l14.591,10.85L143.883,0Z",
    transform: "translate(-114.701)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(0 1.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M113.088,35.158a1.155,1.155,0,0,1-1.378,0L96.4,23.773v11.54A14.6,14.6,0,0,1,115.64,46.52h11.6a1.155,1.155,0,0,0,1.155-1.155V23.773Z",
    transform: "translate(-96.399 -23.773)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(618.86 465.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M42.612,34.229a10.73,10.73,0,0,1-1.191,4.987c-.113.224-.218.238-.431.131q-3.462-1.748-6.934-3.475c-.758-.38-1.516-.763-2.28-1.134a.247.247,0,0,1-.165-.3l.375-2.288c.187-1.148.368-2.3.56-3.444.18-1.08.372-2.158.556-3.238.072-.418.142-.837.2-1.256.028-.192.055-.286.313-.245A10.693,10.693,0,0,1,37.747,25.5a10.282,10.282,0,0,1,3.44,3.584,10.568,10.568,0,0,1,1.35,3.952A6.72,6.72,0,0,1,42.612,34.229Z",
    transform: "translate(-20.09 -20.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 12.57,
    cy: 12.57,
    r: 12.57,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditUsedIcon);
export default __webpack_public_path__ + "static/media/credit-used-icon.23d8ca7d3ec9aed295a76bbe5c81d790.svg";
export { ForwardRef as ReactComponent };